import { formatVnd } from '../lib/format';

export function BudgetBar({
  spent,
  budget,
  compact = false,
}: {
  spent: number;
  budget: number | null;
  compact?: boolean;
}) {
  if (budget == null) {
    return (
      <div className={`flex items-center gap-2 ${compact ? 'text-xs' : 'text-sm'}`}>
        <span className="font-mono tabular-nums text-foreground">{formatVnd(spent)}</span>
        <span className="text-muted-foreground/70">/ —</span>
      </div>
    );
  }
  // Treat zero-budget with non-zero spend as "over budget"; show 100%+ visual.
  const pct = budget > 0 ? (spent / budget) * 100 : spent > 0 ? 100 : 0;
  const clamped = Math.min(pct, 100);
  const overBudget = pct > 100;
  const color =
    pct >= 100
      ? 'bg-destructive'
      : pct >= 80
        ? 'bg-warning'
        : pct >= 50
          ? 'bg-primary'
          : 'bg-success';
  const label = budget === 0 ? '—' : `${pct.toFixed(0)}%`;
  return (
    <div className={compact ? 'space-y-0.5' : 'space-y-1'}>
      <div
        className={`flex items-baseline justify-between gap-2 ${compact ? 'text-xs' : 'text-sm'}`}
      >
        <span className="font-mono tabular-nums text-foreground">
          {formatVnd(spent)}
          <span className="text-muted-foreground"> / {formatVnd(budget)}</span>
        </span>
        <span
          className={`tabular-nums ${overBudget ? 'font-semibold text-destructive' : 'text-muted-foreground'}`}
        >
          {label}
        </span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-background">
        <div
          className={`h-full transition-all ${color}`}
          style={{ width: `${Math.max(clamped, 2)}%` }}
        />
      </div>
    </div>
  );
}
